import React from "react"
import ReactDOM from "react-dom"
import Weatherapp from "./Weatherapp"
import "./weather.css"

ReactDOM.render(<Weatherapp />,
document.getElementById("root"))
